import { useEffect, useState } from "react";
import { useSettings } from "@/context/SettingsContext";

export default function SplashScreen({ onDone }) {
  const { settings } = useSettings();
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHide(true), 2000);
    const t2 = setTimeout(() => onDone(), 2600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onDone]);

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-cream transition-opacity duration-500 ${
        hide ? "opacity-0" : "opacity-100"
      }`}
    >
      <img
        src={settings.logo}
        alt={settings.business_name || "Taanya Homefoods"}
        className="w-44 h-44 sm:w-56 sm:h-56 object-contain rounded-full animate-splash-in"
      />
      <p className="mt-6 font-accent text-2xl text-brand animate-fade-in" style={{ animationDelay: "0.4s" }}>
        Homemade • Made With Love
      </p>
    </div>
  );
}
